/*
 * @Description: Vuex入口
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-25 22:51:50
 */
import { createStore } from 'vuex'
import user from './modules/user'
import shoppingCart from './modules/shoppingCart'

export default createStore({
  strict: true,
  modules: {
    user,
    shoppingCart
  }
})
